export const formatCurrency = (amount, locale = 'pl-PL', currency = 'PLN') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount)
}

export const formatNumber = (value, locale = 'pl-PL', options = {}) => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  }).format(value)
}

export const formatDate = (dateString, locale = 'pl-PL', options = {}) => {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleDateString(locale, options)
}
